import { render, staticRenderFns } from "./sellingprice_changes.vue?vue&type=template&id=26828e50&"
import script from "./sellingprice_changes.vue?vue&type=script&lang=js&"
export * from "./sellingprice_changes.vue?vue&type=script&lang=js&"
import style0 from "./sellingprice_changes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports